<template>
  <div id="guided-creation-invoice-items-wrapper">
    <horizontal-item-scroll-window
      id="add-products-wrapper"
      title="Add products"
    >
      <item-tile
        :selected="true"
        :text="product.name"
        v-for="(product, index) in event.invoice_products"
        :key="index"
        :input="product.priceOption === 'Unit'"
        :initialInputValue="product.pricing.minUnits"
        @input="unitInput(product, $event)"
        :photo="product.photo"
        @primary-icon-clicked="toggleItem('invoice_products', product)"
      />
      <item-tile
        :selected="false"
        :text="product.name"
        v-for="(product, index) in products"
        :key="index"
        :photo="product.photo"
        @click="toggleItem('invoice_products', product)"
      />
    </horizontal-item-scroll-window>
    <horizontal-item-scroll-window
      id="add-adjustments-wrapper"
      title="and adjustments"
    >
      <item-tile
        :selected="true"
        :text="adjustment.name"
        v-for="(adjustment, index) in event.invoice_adjustments"
        :key="index"
        :photo="adjustment.photo"
        @click="toggleItem('invoice_adjustments', adjustment)"
      />
      <item-tile
        :selected="checkEventForPresence('invoice_adjustments', adjustment)"
        :text="adjustment.name"
        v-for="(adjustment, index) in adjustments"
        :key="index"
        :photo="adjustment.photo"
        @click="toggleItem('invoice_adjustments', adjustment)"
      />
    </horizontal-item-scroll-window>
  </div>
</template>
<script>
import HorizontalItemScrollWindow from "../../../../Components/UI/HorizontalItemScrollWindow.vue";
import ItemTile from "../../../../Components/UI/ItemTile.vue";

export default {
  data() {
    return {};
  },
  computed: {
    products() {
      let packages = this.$store.getters.packages;
      let services = this.$store.getters.services;
      let addOns = this.$store.getters.addOns;
      let productsWithType = function (array, type) {
        return array.map((x) => {
          return { ...x, type: type };
        });
      };
      return [
        ...productsWithType(packages, "Package"),
        ...productsWithType(services, "Service"),
        ...productsWithType(addOns, "Add-On"),
      ].filter((x) => {
        return !this.checkEventForPresence("invoice_products", x);
      });
    },
    adjustments() {
      return this.$store.getters.adjustments.filter((x) => {
        return !this.checkEventForPresence("invoice_adjustments", x);
      });
    },
  },
  methods: {
    checkEventForPresence(array, item) {
      let index = this.event[array].findIndex((x) => {
        return item.id
          ? x.config_id === item.id
          : item.config_id
          ? x.config_id === item.config_id
          : x.name === item.name;
      });
      return index > -1 ? true : false;
    },
    toggleItem(array, item) {
      this.$emit("toggle-item", array, item);
    },
    unitInput(product, units) {
      product.pricing.units = units.value;
    },
  },
  created() {},
  components: {
    HorizontalItemScrollWindow,
    ItemTile,
  },
  emits: ["toggle-item"],
  props: ["event"],
};
</script>
<style scoped>
#guided-creation-invoice-items-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
#add-products-wrapper {
  margin-left: 60px;
}

#add-adjustments-wrapper {
  margin-left: 60px;
}

h4 {
  text-align: left;
}
.horizontal-scroll-container {
  display: flex;
  width: 100%;
  overflow-x: scroll;
}

.scroll-padding {
  min-width: 20px;
  height: 100%;
}
</style>
